module.exports = {"themePenal":{"001":"Control Panel","002":"Themed color selection","003":"Main panel selection","004":"Language switching","005":"Crossmania selection","006":"Rotate","007":"sliding","008":"Flip","009":"Rolling","010":"fade out"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = yZm8
// module chunks = 1